export const baseTextColor = 'rgba(255,255,255,0.3)';
export const baseTextColorDarker = '#222';

export const baseIptColorFill = '#111';

export const baseIconColor2 = '#222';
export const baseIconColor4 = '#444';
export const baseIconColor4Inactive = '#111';
